<template>
  <div class="__page_cont">
    <div class="hd">
      <h3 class="tit">하위코드 목록</h3>
    </div>
    <div class="bd">
      <div class="info_summary">
        <span style="float:right;" class="search_area">
        <date-range-picker
          ref="picker"
          v-model="dateRange"
          opens="left"
          :locale-data="dateRangeConfig.locale"
          :linkedCalendars="dateRangeConfig.linkedCalendars"
          :showCustomRangeLabel="dateRangeConfig.showCustomRangeLabel"
          :alwaysShowCalendars="dateRangeConfig.alwaysShowCalendars"
          :applyButtonClasses="dateRangeConfig.applyButtonClasses"
          :ranges="dateRangeConfig.ranges"
          @update="updateRanges"
          applyButtonClasses="_btn_st1"
        >
        </date-range-picker>

      </span>
      </div>
    </div>
    <table class="horiz_tbl" border="0">
      <thead>
      <tr>
        <th width="30px">No.</th>
        <th class="line" width="">코드</th>
        <th class="line" width="50px">회원수</th>
        <th class="line" width="110px">프리매치<br/>참여골드</th>
        <th width="100px">지급조건</th>
        <th width="80px">지급골드</th>
        <th width="100px">파트너<br/>적립골드</th>
        <th class="line" width="110px">라이브<br/>참여골드</th>
        <th width="80px">지급조건</th>
        <th width="100px">지급골드</th>
        <th width="100px">파트너<br/>적립골드</th>
        <th class="line" width="100px">지급합계</th>
        <th class="line" width="100px">파트너<br/>전체 적립골드</th>
      </tr>
      </thead>
      <tbody>

      <template  v-for="(row, key) in users">
      <tr>
        <td>{{ key + 1 }}</td>
        <td class="line"><a class="_lnk" href="javascript:;" @click="setUserCode(row.code)">{{ row.code }}</a></td>
        <td class="line">{{ numberToString(row.child_user) }}명</td>
        <td class="line">{{ (row.match_bet_amount) }}</td>
        <td>{{ row.match_rate * 100 }}%</td>
        <td>{{ (row.match_amount) }}</td>
        <td class="c_free">{{ row.partnerMatchPrice }}</td>
        <td class="line">{{ (row.live_bet_amount) }}</td>
        <td>{{ row.live_rate * 100 }}%</td>
        <td>{{ (row.live_amount) }}</td>
        <td class="c_live">{{ row.partnerLivePrice }}</td>
        <td class="c_p line">{{ row.amount_total }}</td>
        <td class="c_p line">{{ row.partnerTotalPrice }}</td>
      </tr>
      </template>

      <tr v-if="users.length <= 0">
        <td colspan="13">데이터가 없습니다.</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
  name: "partner-user",
  components: {
    DateRangePicker
  },
  data() {

    const today =  moment().toDate();
    const now = moment().format('YYYY-MM-DD')
    const fromDate = moment().add(-1, 'months').format('YYYY-MM-DD')


    this.$store.dispatch('partner/setDate', {
      startDate: fromDate,
      endDate:now
    })

    return {
      from : fromDate,
      to : now,
      search : '',
      dateRange: {
        startDate : fromDate,
        endDate : now
      },
      dateRangeConfig : {
        linkedCalendars: false,
        showCustomRangeLabel: false,
        alwaysShowCalendars: true,
        applyButtonClasses: '_btn_st1',
        ranges: {
          '오늘': [today, today]
          , '1주일': [moment().subtract(7, 'days').toDate(), today]
          , '1개월': [moment().subtract(1, 'month').toDate(), today]
          , '3개월': [moment().subtract(3, 'month').startOf('month').toDate(), today]
          , '6개월': [moment().subtract(6, 'month').startOf('month').toDate(), today]
        },
        locale : {
          format: 'yyyy-mm-dd',
          separator: ' ~ ',
          applyLabel: '확인',
          cancelLabel: '취소',
          weekLabel: '주',
          customRangeLabel: '기간',
          daysOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
          monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        },
      },
      page: this.$route.query.page ? this.$route.query.page : 1,
      totalEntries: 0,
      totalPage: 1,
      totalCount: 0,
      pageSize: 12,
    }
  },
  created() {
    this.getList();
  },
  methods:{
    checkOpen(range){

    },
    updateRanges(range){
      this.dateRange = {
        startDate : moment(range.startDate).format("YYYY-MM-DD"),
        endDate : moment(range.endDate).format("YYYY-MM-DD"),
      }

      this.$store.dispatch('partner/setDate', {
        startDate: moment(range.startDate).format("YYYY-MM-DD"),
        endDate: moment(range.endDate).format("YYYY-MM-DD"),
      })


      this.getList()
    },
    async getList() {
      const res = await this._get("/v1/partner", this.condition);
      this.$store.dispatch('partner/setInfo',res.data.info)
      this.$store.dispatch('partner/setUsers',res.data.users)
    },
    setUserCode(code){
      this.$store.dispatch('partner/setCode',code)
    },
  },
  computed: {
    condition() {
      return {
        page: this.page,
        from: this.dateRange.startDate,
        to: this.dateRange.endDate
      }
    },
    info() {
      return this.$store.getters['partner/info'];
    },
    users() {
      return this.$store.getters['partner/users'];
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partner/partner-user.vue